import { BID_STATUS_STRING } from '../constants/index';

export const GET_BID_STATUS_CLASS = (status: string): string => {
	switch (status.toLowerCase()) {
		case BID_STATUS_STRING.ACCEPTED.toLowerCase():
		case BID_STATUS_STRING.SIGNED.toLowerCase():
		case BID_STATUS_STRING.DRAFT.toLowerCase():
			return 'accepted-chip';
		case BID_STATUS_STRING.SELECTED.toLowerCase():
		case BID_STATUS_STRING.ASSIGNED.toLowerCase():
			return 'selected-chip';
		case BID_STATUS_STRING.CANCELLED.toLowerCase():
			return 'label-warning';
		case BID_STATUS_STRING.COUNTERED.toLowerCase():
			return 'countered-chip';
		case BID_STATUS_STRING.DECLINED.toLowerCase():
			return 'declined-chip';
		case BID_STATUS_STRING.EXPIRED.toLowerCase():
			return 'label-primary';
		case BID_STATUS_STRING.INVITED.toLowerCase():
		case BID_STATUS_STRING.NEW.toLowerCase():
			return 'invited-chip';
		case BID_STATUS_STRING.RESPONSE_RECEIVED.toLowerCase():
		case BID_STATUS_STRING.VIEWED.toLowerCase():
		case BID_STATUS_STRING.SCHEDULED.toLowerCase():
			return 'viewed-chip';
	}
};
